import { useState } from "react";
import { useDispatch } from "react-redux";
import ErrorBox from "../../../helpers/errors_notifications/ErrorBox";
import { checkEmail } from "../../Validator/Validator";
import { internalTransferCoin } from "../../../services/adminServices";
import { userCoinBalance } from "../../../actions/user";
import { errorMessage, successMessage } from "../../../utils/messages";
//Icon
import styles from "./InternalTransfer.module.scss";
import WaningIcon from "../../../styles/icon/warning.svg";
export function Enter2FACode({
  internalTransferDetails,
  setInternalTransferDetails,
  name,
}) {
  //Change name as asset
  const dispatch = useDispatch();
  const handleSubmitWithdraw = async (e) => {
    e.preventDefault();
    const re = /^[0-9\b]+$/;
    if (!internalTransferDetails.token) return;
    if (internalTransferDetails.token.length < 6) return;
    if (!re.test(internalTransferDetails.token)) return;

    const { emailAddress, transferAmount, token } = internalTransferDetails;
    const withdrawInfo = {
      asset: name,
      token,
      transferAmount,
      emailAddress,
    };
    const { status, data } = await internalTransferCoin(withdrawInfo);
    if (status === 200) {
      if (data?.message) {
        dispatch(userCoinBalance(name));
        setInternalTransferDetails({
          ...internalTransferDetails,
          token: "",
          transferAmount: "",
          emailAddress: "",
          openTwoFac: false,
        });
        successMessage(data.message);
      } else if (data.error) {
        errorMessage(data.error);
      } else {
        errorMessage("خطایی رخ داد، لطفا مجددا تلاش کنید");
      }
    } else {
      if (data.status === 404) {
        setInternalTransferDetails({
          ...internalTransferDetails,
          openTwoFac: false,
        });
        errorMessage("خطایی رخ داد، لطفا مجددا تلاش کنید");
      } else {
        setInternalTransferDetails({
          ...internalTransferDetails,
          openTwoFac: false,
        });
        errorMessage("خطایی رخ داد، لطفا مجددا تلاش کنید");
      }
    }
  };
  return (
    <div className={styles.container_of_enter2FACode}>
      <form onClick={(e) => handleSubmitWithdraw(e)}>
        <div>
          برای تائید شناسایی دو عاملی خود,کد تولید شده در نرم افزار را ثبت کنید.
        </div>
        <div>
          <input
            type="number"
            placeholder="کد Google Authenticator"
            onChange={(e) =>
              setInternalTransferDetails({
                ...internalTransferDetails,
                token: e.target.value,
              })
            }
            value={internalTransferDetails.token}
          />
        </div>
        <div>
          کد ۶ رقمی نمایش داده شده در نرم افزار Google Authenticator را ثبت کنید
        </div>
        <div>
          <button type="submit">ثبت درخواست</button>
        </div>
      </form>
    </div>
  );
}
export default function InternalTransfer({ balances, name }) {
  //Handle Error's
  const [errorInt, setErrorInt] = useState("");
  const [internalTransferDetails, setInternalTransferDetails] = useState({
    transferAmount: "",
    emailAddress: "",
    token: "",
    openTwoFac: false,
  });

  const handleInternalTransferAmount = (amount, maxAm) => {
    const maxAmount = balances.asset.balance - balances.asset.locked;
    if (maxAmount <= 0) {
      setInternalTransferDetails({
        ...internalTransferDetails,
        transferAmount: 0,
      });
      setErrorInt("موجودی کافی نیست");
    } else if (parseFloat(amount) > parseFloat(maxAmount)) {
      setInternalTransferDetails({
        ...internalTransferDetails,
        transferAmount: maxAmount,
      });
      if (!maxAm) setErrorInt("موجودی کافی نیست");
    } else {
      setInternalTransferDetails({
        ...internalTransferDetails,
        transferAmount: amount,
      });
    }
  };

  //CHECK STATE and SUBMIT FOR FINALLY SUBMIT
  const handleConfirmInternalDetails = (e) => {
    e.preventDefault();

    if (!checkEmail(internalTransferDetails.emailAddress))
      return setErrorInt("ایمیل به درستی وارد نشده است");
    if (
      internalTransferDetails.transferAmount === 0 ||
      internalTransferDetails.transferAmount === ""
    )
      return setErrorInt("مبلغ وارد شده نامعتبر است");
    setInternalTransferDetails({
      ...internalTransferDetails,
      openTwoFac: true,
    });
  };
  if (internalTransferDetails.openTwoFac)
    return (
      <Enter2FACode
        setInternalTransferDetails={setInternalTransferDetails}
        internalTransferDetails={internalTransferDetails}
        name={name}
      />
    );
  return (
    <>
      <ErrorBox text={errorInt} setText={setErrorInt} />

      <div className={styles.container}>
        <form onSubmit={(e) => handleConfirmInternalDetails(e)}>
          <div className={styles.showNotificationForEmailTransfer}>
            <div className={styles.iconOfNotificationNetwork}>
              <img src={WaningIcon} alt="" width={20} height={20} />
            </div>
            <div className={styles.titleNotificationNetwork}>
              <div>
                با داشتن ایمیل دوستان خود میتوانید به اکانت آنها بدون کارمزد ارز
                انتقال دهید.
              </div>
            </div>
          </div>
          <div className={styles.value_for_withdraw_container}>
            <input
              className="changeBackgroundToWhite changeFontColorToBlack"
              placeholder="آدرس ایمیل"
              onChange={(e) =>
                setInternalTransferDetails({
                  ...internalTransferDetails,
                  emailAddress: e.target.value,
                })
              }
              value={internalTransferDetails.emailAddress}
            />
          </div>
          <div className={styles.value_for_withdraw_container}>
            <input
              className="changeBackgroundToWhite changeFontColorToBlack"
              placeholder="مقدار تراکنش"
              type="number"
              onChange={(e) => handleInternalTransferAmount(e.target.value)}
              value={internalTransferDetails.transferAmount}
            />
            <div
              className={styles.button_of_all_balance}
              onClick={() =>
                handleInternalTransferAmount(
                  balances.asset.balance - balances.asset.locked,
                  true
                )
              }
            >
              کل موجودی
            </div>
          </div>
          <div
            className={`changeTextColorToGreen ${styles.NotificationForWithdraw}`}
          >
            <p>توجه</p>
            <p>
              1.دقت کنید برداشت ارز فقط در شبکه صحیح انجام شود. ارزفی هیچگونه
              مسيولیتی در قبال از دست رفتن سرمایه شما ندارد. 2.پس از تایید شما
              ارز به شبکه تحویل داده شد و باید منتظر دریافت تاییده در شبکه ماند
            </p>
          </div>
          <button type="submit" className={styles.button_for_submit}>
            ثبت درخواست
          </button>
        </form>
      </div>
    </>
  );
}
